import { useMemo } from "react";
import usePageComponents from "./page-components.hook";
import { TrackDocumentType } from "@/modules/property-tracks/types";

const commonDocumentTypes: TrackDocumentType[] = ["Media", "Contracts"];

const documentTypeComponentMap: Record<string, TrackDocumentType> = {
  "property-contracts": "Contracts",
  "property-power-of-attorney": "PowerOfAttorney",
  "property-owner-id": "OwnerID",
  "property-material-selection": "MaterialSelection",
  "property-layouts": "Layouts",
  "property-drawings": "Drawings",
  "property-proposals": "Proposals",
  "property-floor-plans": "FloorPlans",
  "property-master-plans": "MasterPlans",
} as const;

const useTrackDocumentTypes = (trackTypeId?: number) => {
  const { data: components } = usePageComponents({
    trackTypeId: trackTypeId,
    page: "property-details-documents",
  });

  const documentTypes: TrackDocumentType[] = useMemo(() => {
    const filteredCategories: TrackDocumentType[] = [...commonDocumentTypes];

    components?.data.forEach((component) => {
      const mappedComponent = documentTypeComponentMap[component.name];
      if (mappedComponent) {
        filteredCategories.push(mappedComponent);
      }
    });

    return filteredCategories;
  }, [components]);

  return documentTypes;
};

export default useTrackDocumentTypes;
